<div class="input-wrapper">
  <address-comp [question]="question" (addressSelected)="onAddressSelected($event)"></address-comp>
</div>

<popup-with-dismiss-button *ngIf="sharedConfig.showPopupWithDismissButton"></popup-with-dismiss-button>
